import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Get accumulated amount.
 */
export const getAccumulatedAmount = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/home/montoacumulado`)
)

/**
 * Get accumulated amount detail.
 */
export const getAccumulatedAmountDetail = factoryAuthService(({ year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/home/montoacumuladodetalle/${year}`)
)
